/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { html, nothing } from 'lit';
// eslint-disable-next-line import/extensions
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { ConsentGroup, ConsentType } from '@mfe/types/common';
import { cancelMicrofrontend } from '@mfe/store/consents';
import store from '@mfe/store';
import type TefComsConsentGroup from '../../tef-coms-group';
import { filterPredicator } from '../util';

export const clickTextTemplate = (
  checkBoxId: string,
  comsConsentGroup: TefComsConsentGroup,
) => html`
    <one-text padding="xs">
      <one-group direction="row" gap="sm" wrap="noWrap" align-items="flex-start">
        <one-checkbox id=${checkBoxId} @change=${comsConsentGroup.oneclickAction.bind(comsConsentGroup)}>
        </one-checkbox>
        <one-text as="span" for=${checkBoxId}>
            ${unsafeHTML(comsConsentGroup.consentGroup.text)}
          </one-text>
      </one-group>
    </one-text>
    `;

export const clickConsentsContainerTemplate = (
  stylecontext: string,
  comsConsentGroup: TefComsConsentGroup,
  collapsibleOpenGroupName: string,
) => {
  const { oneclickCollapsible } = comsConsentGroup.consentGroup;
  return html`
    <one-accordion
      cloak
      context="${stylecontext}"
      ?is-open="${comsConsentGroup.groupName === collapsibleOpenGroupName}"
    >
      <one-accordion-item once>
        <div slot="summary">
          ${oneclickCollapsible ? unsafeHTML(oneclickCollapsible)
    : 'Wenn ich einzelne Kontaktkanäle und Verarbeitungsvorgänge von meiner '
          + 'Auswahl ausschließen möchte, kann ich hier gesonderte Einwilligungen erteilen.'}
        </div>
        <one-list>
          <one-stack gap="md">
            ${comsConsentGroup.groupConsents('group')}
          </one-stack>
        </one-list>
        </one-accordion-item>
      </one-accordion>
    `;
};

export const groupConsentsTemplate = (
  comsConsentGroup: TefComsConsentGroup,
) => {
  const { consents, required } = comsConsentGroup.consentGroup;
  return html`
    <one-list>
      ${consents /* eslint-disable indent, @typescript-eslint/indent */
        .filter(filterPredicator)
        .map(
          (consent) => html`
            ${consent.hintBefore ? html`<one-list-item class="coms-hint-before">${unsafeHTML(consent.hintBefore)}</one-list-item>` : nothing}
            <one-list-item class="coms-consent">
              <tef-coms-consent .consent=${consent} ?required=${required}></tef-coms-consent>
            </one-list-item>
            ${consent.hintAfter ? html`<one-list-item class="coms-hint-after">${unsafeHTML(consent.hintAfter)}</one-list-item>` : nothing}`,
        )/* eslint-enable indent, @typescript-eslint/indent */}
    </one-list>
  `;
};

export const withdrawalTemplate = (
  comsConsentGroup: TefComsConsentGroup,
  checkboxId: string,
) => {
  const { denyall } = comsConsentGroup.consentGroup;
  return html`
        ${/* eslint-disable indent, @typescript-eslint/indent */
        html`
          <one-box>
            <one-stack gap="xs">
              <one-checkbox
                id=${checkboxId}
                .checked=${comsConsentGroup.noConsentSet}
                @change=${comsConsentGroup.denyAction.bind(comsConsentGroup)}
              >
                <one-text as="span" for=${checkboxId}>
                  ${unsafeHTML(denyall.toString())}
                </one-text>
              </one-checkbox>
            </one-stack>
          </one-box>
        `}
    `;
  };

  export const groupViewTemplate = (
    comsConsentGroup: TefComsConsentGroup,
    consentGroupsView: ConsentGroup[],
    filteredConsents: ConsentType[],
    stylecontext: string,
  ) => {
    const {
        header, text, footer, denyallView,
    } = consentGroupsView[comsConsentGroup.groupIndex];

    // Do we need a "Zurück" button?
    let backButtonHtml = html`${nothing}`;
    if (comsConsentGroup.mode.includes('buttons:cancel')) {
      backButtonHtml = html`
        <one-spacer size="fill"></one-spacer>
        <one-button @click=${() => { store.dispatch(cancelMicrofrontend()); }} variant="plain">Zurück</one-button>
      `;
    }

    return html`
       <one-content>
        <one-stack gap="lg">
          <one-heading level="h4">
            ${header.replace(/<[^>]+>/g, '')}
          </one-heading>
          <one-text as="p">
            ${unsafeHTML(text)}
          </one-text>
          ${(filteredConsents.length === 0 && denyallView) ? html`
          <one-paper background="legal-2" padding="md">${unsafeHTML(denyallView)}</one-paper>
            ` : html`
            <tef-coms-collapsible-group context="${stylecontext}">
              <one-stack gap="sm">
                ${filteredConsents.map((consent) => html`
                  <one-details variant="flipped">
                    <div slot="summary">${unsafeHTML(consent.shortInfo)}</div>
                    <tef-coms-consent .mode=${comsConsentGroup.mode} .consent=${consent}></tef-coms-consent>
                  </one-details>
                `)}
              </one-stack>
            </tef-coms-collapsible-group>
          `}
          ${footer ? html`
            <one-text as="p">
              ${unsafeHTML(footer)}
            </one-text>
          ` : nothing}
        </one-stack>
    </one-content>
    <one-spacer size="md"></one-spacer>
    <one-button-group>
        <one-button @click=${comsConsentGroup.openGroupForEdit.bind(comsConsentGroup)} data-test-id="update">Ändern</one-button>
        ${backButtonHtml}
      </one-button-group>
    <one-spacer size="md"></one-spacer>
    </one-section>`;
  };

  export const groupTemplate = (comsConsentGroup: TefComsConsentGroup) => {
    const { header, footer, oneclick: oneclick1 } = comsConsentGroup.consentGroup;
       return html`
       <one-content>
          <one-stack gap="sm">
            <one-heading level="h4">
              ${header.replace(/<[^>]+>/g, '')}
            </one-heading>
            <one-text as="p">
                ${oneclick1 ? comsConsentGroup.groupOneclickText : comsConsentGroup.groupText}
              </one-text>
            <one-stack gap="md">
                ${oneclick1 ? comsConsentGroup.groupOneclickConsentsContainer : comsConsentGroup.groupConsents()}
            </one-stack>

          ${footer ? html`
            <one-text as="p">
              ${unsafeHTML(footer)}
            </one-text>
          ` : nothing}

          ${comsConsentGroup.withdrawal}
          </one-stack>
          <one-spacer size="md"></one-spacer>
      </one-content>
      `;
    };
